import { Component } from '@verndale/core';
import Player from '@vimeo/player';

class BookingHeroMasthead extends Component {
  private playing = false;
  private player: Player | null = null;
  private classes = {
    playing: 'is-playing',
    paused: 'is-paused'
  };

  constructor(el: HTMLElement) {
    super(el);

    this.initVimeoPlayer();
  }

  setupDefaults() {
    this.dom = {
      container: this.el.querySelector('.booking-hero-mast__video') as HTMLElement,
      wrapper: this.el.querySelector('.booking-hero-mast__media-wrapper') as HTMLElement,
      btnPlayPause: this.el.querySelector('.booking-hero-mast__play-pause') as HTMLButtonElement
    };
  }

  addListeners() {
    (this.dom.btnPlayPause as HTMLButtonElement)?.addEventListener(
      'click',
      this.handlelayPause.bind(this)
    );
  }

  initVimeoPlayer() {
    console.log('initVimeoPlayer');
    const container = this.dom.container as HTMLElement;
    const vimeoId = container.dataset.videoId || '';
    if (this.playing || vimeoId?.length < 1) return;
    const options01 = {
      id: parseInt(vimeoId),
      allow: 'autoplay; fullscreen; picture-in-picture; background; muted',
      width: window.innerWidth,
      autoplay: true,
      background: true,
      byline: false,
      controls: false
    };

    if (this.dom.container instanceof HTMLElement) {
      if (this.playing) return;
      const player = new Player(this.dom.container, options01);
      this.player = player;

      player.ready().then(() => {
        player.play();
        player.on('progress', data => {
          if (data.percent > 0.1) {
            this.playing = true;
            (this.dom.wrapper as HTMLElement).classList.add(this.classes.playing);
            (this.dom.btnPlayPause as HTMLButtonElement).style.display = 'flex';
            player.off('progress');
          }
        });
      });
    }
  }

  handlelayPause() {
    const player = this.player;

    if (player) {
      player.ready().then(() => {
        (this.dom.wrapper as HTMLElement).classList.remove(
          this.classes.playing,
          this.classes.paused
        );

        this.playing = !this.playing;
        (this.dom.wrapper as HTMLElement).classList.add(
          this.playing ? this.classes.playing : this.classes.paused
        );

        if (this.playing) {
          player.play();
        } else {
          player.pause();
        }
      });
    }
  }
}

export default BookingHeroMasthead;
